export const VERIFICATION_STARTED = '@question-navigation/VERIFICATION_STARTED';
export const VERIFICATION_DONE = '@question-navigation/VERIFICATION_DONE';
export const VERIFICATION_FAILED = '@question-navigation/VERIFICATION_FAILED';
export const VERIFICATION_SUCCESS = '@question-navigation/VERIFICATION_SUCCESS';

export const RESET = '@question-navigation/RESET';
export const UPDATE_NAVIGATION = '@question-navigation/UPDATE_NAVIGATION';

export const SET_LAST_QUESTION = '@question-navigation/SET_LAST_QUESTION';